<template>
  <div class="animated fadeIn">
    <div class="loading" v-if="loading">
      <div class="spinner"></div>
    </div>

    <div class="row mb-1 align-self-center">
      <b-col>
        URL :
        <a href="" class="a_tag">
          {{ dropzoneOptions.url }}
        </a>
      </b-col>
      <b-col class="text-danger font-weight-bold ml-2 text-right">
        * Require authentication, Webshell suspicious files can also be uploaded
        <strong v-if="so.totalRows">
          (Total : {{ so.totalRows | number }})
        </strong>
      </b-col>
    </div>

    <div class="row mb-2">
      <div class="col-xl-12 col-md-12 d-flex align-self-center">

        <b-button type="button" class="btn btn-cancel btn-block" variant="warning" @click="clear">
          Clear
        </b-button>
      </div>
    </div>

    <b-progress class="animated fadeIn fadeOut" v-if="dropzone && dropzone.bar_value > 0" :max="100" show-value
      style="width:100%;" :value="dropzone.bar_value"></b-progress>
    <hr>
    <b-progress class="animated fadeIn fadeOut" v-if="dropzone && dropzone.count > 0"
      :value="(dropzone.done / dropzone.count) * 100" show-value :max="dropzone.count" :precision="0"
      style="width:100%;"></b-progress>

    <div class="row mt-2">
      <div class="col-xl-12">
        <vue-dropzone @vdropzone-error="noti_error" @vdropzone-total-upload-progress="noti_progress"
          @vdropzone-success="noti_upload_item" @vdropzone-queue-complete="noti_upload_all"
          @vdropzone-file-added="noti_add" ref="dropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
      </div>
    </div>

    <hr>

    <!-- table -->
    <b-card v-show="so.adv" class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>Registed_at</label>
            <b-form inline>
              <date-picker class="mt-2 mr-2" v-model="so.opt.created_at_sd" style="width: 140px" :confirm="true"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              ~
              <date-picker class="ml-2" v-model="so.opt.created_at_ed" style="width: 140px" :confirm="true"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group class="float-right">
        <b-button class="mr-1" size="sm" variant="danger" @click="so.adv = false"> Close </b-button>
        <b-button class="mr-1" size="sm" variant="light" @click="resetField"> Reset </b-button>
        <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
      </b-form-group>
    </b-card>

    <b-row class="mt-3">
      <b-col md="4">
        <b-form-fieldset style="width : 120px" size="sm">
          <b-form-select :options="so.pageoptions" v-model="so.perPage">
          </b-form-select>
        </b-form-fieldset>
      </b-col>
      <b-col md="4">
        <b-form-fieldset style="width : 20%" size="sm" class="d-inline ml-2">
          Family
        </b-form-fieldset>
        <b-form-fieldset style="width : 120px" size="sm" class="d-inline ml-2">
          <b-form-select :options="family" v-model="model.family">
          </b-form-select>
        </b-form-fieldset>
        <b-button size="sm" class="ml-1" variant="primary" @click="() => modal_add = true"> Add </b-button>
      </b-col>
      <b-col>
        <b-input-group style="" size="sm" class="float-right">
          <b-input-group-prepend>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
            <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
            <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
              <b-dropdown-item size="sm" @click="so.sk = 'origin'; so.skt = 'From'">From</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'file_hash'; so.skt = 'Hash(MD5)'">Hash(MD5)</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'extension'; so.skt = 'Extension'">Extension</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'extension_category'; so.skt = 'Extension Category'">Extension
                Category</b-dropdown-item>
            </b-dropdown>
          </b-input-group-prepend>
          <b-input v-model="so.sv" @keyup.enter="refresh()"></b-input>
          <b-input-group-append>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa"
                :class="{ 'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mt-3 mb-3">
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-danger" @click="webshell"
          :disabled="loading">
          Webshell Regist
        </b-button>
      </b-col>
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-primary" @click="normal"
          :disabled="loading">
          Normal Regist
        </b-button>
      </b-col>
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-dark" @click="unknown"
          :disabled="loading">
          Analysis Regist
        </b-button>
      </b-col>
      <b-col>
        <b-button type="button" class="btn btn-cancel btn-block" variant="outline-warning" @click="remove"
          :disabled="loading">
          Disable
        </b-button>
      </b-col>
    </b-row>

    <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
      :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" class="">
      <template #cell(id)="row">{{ row.item.id }}</template>
      <template #cell(is_alive)="row">
        <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
        <b-badge v-else variant="secondary">Disable</b-badge>
      </template>
      <template #cell(file_hash)="row">
        <a href="javascript:void();" @click="detail(row.item)">{{ row.item.file_hash | truncate(50) }}</a>
      </template>
      <template #cell(extension)="row">
        {{ row.item.extension || '-' }}
      </template>
      <template #cell(extension_category)="row">{{ row.item.extension_category || '-' }}</template>
      <template #cell(created_at)="row">{{ row.item.created_at | datetime2 }}</template>
    </b-table>

    <hr>

    <b-row>
      <b-col>
      </b-col>
      <b-col class="mt-1 d-flex justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage"
          prev-text="Prev" next-text="Next" />
      </b-col>
      <b-col>
      </b-col>
    </b-row>

    <!-- modal area -->

    <b-modal title="Create" class="modal-info" v-model="modal_add" @ok="() => family.push(model)" ok-variant="info">

      <b-row class="mb-4">
        <b-col sm="2" md="2" lg="2" class="text-sm-right">Name :</b-col>
        <b-col>
          <b-input type="text" v-model="model.text"></b-input>
        </b-col>
        <b-col sm="1" md="1" lg="1"></b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col sm="2" md="2" lg="2" class="text-sm-right">Value :</b-col>
        <b-col>
          <b-input type="text" v-model="model.value"></b-input>
        </b-col>
        <b-col sm="1" md="1" lg="1"></b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
import config from '@/f1/config'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import moment from 'moment-timezone';
import _ from 'lodash';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '1 rows', value: 1 },
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 },
    { text: '500 rows', value: 500 },
    { text: '5000 rows', value: 5000 },
  ]
});

export default {
  name: 'UploadUser',
  components: { DatePicker, vSelect, vueDropzone },
  data: () => ({
    modal: { text: '', value: '' },
    modal_add: false,
    loading: false,
    family: [
      { text: '-', value: '' },
    ],
    model: {
      family: ''
    },
    dropzone: { bar_value: 0, count: 0, done: 0 },
    dropzoneOptions: {
      url: location.hostname == 'localhost' ? `${config.baseURL}/api/v3/dms/upload/user` : `${location.protocol}//${location.hostname}/api/v3/dms/upload/user`,
      thumbnailWidth: 150,
      maxFilesize: 20, // unit is
      addRemoveLinks: true,
      parallelUploads: 3,
      chunking: false,
      duplicateCheck: true,
      headers: {
        // 'ContentType' : 'application/json',
        'Authorization': 'Bearer ' + auth.token
      },
      dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
    },
    datepicker,
    so: default_opt(),
    hash_list: [],
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', sortable: true, label: 'No' },
        { key: 'is_alive', sortable: true, label: 'Enable' },
        { key: 'file_hash', sortable: true, label: 'Hash(md5)' },
        { key: 'extension', sortable: true, label: 'Extenstion' },
        { key: 'extension_category', sortable: true, label: 'Ext Category' },
        { key: 'origin', sortable: true, label: 'From' },
        { key: 'created_at', sortable: true, label: 'Registed_at' }
      ]
    }
  },
  methods: {
    async normal() {
      try {
        this.loading = true;
        let rs = await api.dms.upload.normal(this.hash_list);
        console.log("rs", rs)
        this.refresh()
        this.$toastr.s("refreshed")

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },
    async remove() {
      try {
        this.loading = true;
        let rs = await api.dms.upload.remove(this.hash_list);
        console.log("rs", rs)
        this.refresh()
        this.$toastr.s("refreshed")

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },
    async webshell() {
      try {
        this.loading = true;
        let rs = await api.dms.upload.webshell(this.hash_list);
        console.log("rs", rs)
        this.refresh()
        this.$toastr.s("refreshed")

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },
    async unknown() {
      try {
        this.loading = true;
        let rs = await api.dms.upload.unknown(this.hash_list);
        console.log("rs", rs)
        this.refresh()
        this.$toastr.s("refreshed")

      } catch (e) { this.$toastr.e(e.data || e); }
      finally { this.loading = false; }
    },

    // start dropzone function
    processing() { return this.$refs.dropzone.processQueue(); },
    clear() {
      this.$refs.dropzone.removeAllFiles();
      this.refresh();
    },
    noti_add(rs) { console.log('noti_add', rs.name); this.dropzone.count += 1; },
    noti_error(rs) { this.$toastr.w(rs.name, "duplicate"); console.error('noti_error', rs.name); this.$refs.dropzone.removeFile(rs); this.dropzone.done += 1 },
    noti_progress(rs) { console.log('noti_progress', rs); this.dropzone.bar_value = rs * 10; },
    noti_upload_item(rs) { this.$toastr.i(rs.name, rs.status); this.$refs.dropzone.removeFile(rs); this.dropzone.done += 1; },
    noti_upload_all() {
      this.$toastr.s("processing", "complated")
      this.refresh();
    },

    resetField() { this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      this.$refs._list && this.$refs._list.refresh();
      this.dropzone.bar_value = 0;
      this.dropzone.done = 0;
      this.dropzone.count = 0;
    },
    getRowCount() { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok: ctx.sortBy,
        od: ctx.sortDesc ? 'd' : 'a',
        pg: ctx.currentPage || this.so.currentPage || 1,
        pc: ctx.perPage || this.so.perPage || 10,
        sk: this.so.sk || 'file_hash',
        sv: (this.so.sv || '').trim(),
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [{ name: 'is_del', op: '=', value: false }, { name: 'is_clear', op: '=', value: false }, { name: 'is_batch', op: '=', value: false }, { name: 'user_id', op: '>', value: 0 }], or: [], sort: [] }
      // order
      if (so.ok) { search.sort.push({ name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search

      if (so.sk && so.sv) {
        if (!so.ok) {
          search.sort.push({ name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({ name: so.sk, value: `%${so.sv.trim()}%`, op: 'like' });
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if (value != null && value != "") {
          switch (key) {
            case 'created_at_sd': search.and.push({ name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed': var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({ name: 'created_at', value: d, op: '<' }); break;
            default: search.and.push({ name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try {
        let rs = await api.dms.upload.list(search);
        this.so.totalRows = rs.count;

        this.hash_list = _.map(rs.result, x => x.file_hash)

        return rs.result;

      } catch (e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push({ name: 'cti_webshell', params: { id: item.id } }); },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
<style>
